export function commaSeperated(n) {
    const a = String(n).replace(',', '');
    return Number(a).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
}